export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/api-sender": [3],
		"/asset": [4],
		"/asset/[domain]": [5],
		"/attachment": [6],
		"/campaign-template": [9],
		"/campaign": [7],
		"/campaign/[id]": [8],
		"/company": [10],
		"/company/[id]": [11],
		"/dashboard": [12],
		"/dashboard/campaigns": [13],
		"/dashboard/events": [14],
		"/domain": [15],
		"/email": [16],
		"/email/[id]/attachments": [17],
		"/filter": [18],
		"/install": [19],
		"/login": [20],
		"/oauth-provider": [21],
		"/page": [22],
		"/profile": [23],
		"/proxy": [24],
		"/recipient": [25],
		"/recipient/group": [27],
		"/recipient/group/[id]": [28],
		"/recipient/orphaned": [29],
		"/recipient/[id]": [26],
		"/remote-browser": [30],
		"/sessions": [31],
		"/settings": [32],
		"/settings/update": [33],
		"/smtp-configuration": [34],
		"/tools": [35],
		"/user": [36],
		"/webhook": [37]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';